import React from "react";
import { DateInput, TimeInput } from "semantic-ui-calendar-react";
import { Form } from "semantic-ui-react";

const DatePeriodFilters = (props) => {
  const {
    fromDate = "fromDate",
    toDate = "toDate",
    fromTime = "fromTime",
    toTime = "toTime",
    dateFormat = "YYYY-MM-DD",
    onChange,
    data,
    showTimeFilters = true,
    inputWidth = "",
  } = props;

  const dateFields = [
    {
      id: "from-date",
      control: DateInput,
      name: fromDate,
      label: <b style={{ paddingRight: "0.5em" }}>From:</b>,
      placeholder: "Date",
      dateFormat,
    },
    {
      id: "to-date",
      control: DateInput,
      name: toDate,
      label: <b style={{ paddingRight: "0.5em" }}>To:</b>,
      placeholder: "Date",
      dateFormat,
    },
  ];

  const timeFields = [
    {
      id: "from-time",
      control: TimeInput,
      name: fromTime,
      placeholder: "Time",
    },
    {
      id: "to-time",
      control: TimeInput,
      name: toTime,
      placeholder: "Time",
    },
  ];

  const fields = [...dateFields, ...(showTimeFilters ? timeFields : [])];

  return fields.map((field, index) => {
    const value = data[field.name] || "";
    const { control: ControlComponent, ...fieldProps } = field;

    return (
      <Form.Field key={index}>
        <ControlComponent
          iconPosition="left"
          closable={true}
          value={value}
          onChange={onChange}
          {...fieldProps}
          style={{ width: inputWidth }}
          animation="fade"
          popupPosition="bottom center"
          clearable
        />
      </Form.Field>
    );
  });
};

export default DatePeriodFilters;
